import {
    DropdownData,
    FilteredValue,
    InputType,
    Form,
    FormField,
    FormSection,
    FormType,
    ReactiveFormStableValueChange,
} from '@fitogest/reactive-form-builder/interfaces';
import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {BaseForm} from '../../../base-form';
import {RecogidasApiService} from '../../../../service/api/recogidas-api.service';
import {FincasApiService} from '../../../../service/api/fincas-api.service';
import {FormCommonApiService} from '../../../../service/api/formcommon-api.service';
import {build, list, pool} from '@fitogest/reactive-form-builder/utils';
import {Utils} from '../../../../common/utils';
import { environment } from 'src/environments/environment';
import { ClientesApiService } from 'src/app/service/api/clientes-api.service';
import { SiexApiService } from 'src/app/service/api/siex-api.service';
import moment from 'moment';

import { RecogidaModel } from 'src/app/models/recogida.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { ClienteModel } from 'src/app/models/cliente.model';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { getDropdownSelectedSingle } from '@fitogest/reactive-form-builder/utils';

@Component({
    selector: 'app-nueva-carga',
    standalone: false,
    templateUrl: './recogidas-form.component.html',
    styleUrls: ['./recogidas-form.component.scss']
})
export class RecogidasFormComponent extends BaseForm<RecogidaModel> implements OnInit {

    public appName = environment.appName;
    public sectorName = environment.features.sectorName;
    public parcelasName = environment.features.parcelasName;
    public tipoSuperficieParcelas = environment.features.hasSuperficieCultivada
        ? 'S.\xa0C.'
        : 'S.\xa0Sigpac';
    public showClientesCooperativa = environment.features.showClientesCooperativa;
    public textoSuperficie = environment.features.textoSuperficie;

    public reactiveForm!: { formType: FormType; model: Partial<RecogidaModel>; formFields: Form<RecogidaModel> };
    public override model: RecogidaModel = {};
    public reactiveFormRecordId = '';

    public distributionOrder = [
        3, 3, 3
    ];

    public fincas: DropdownData<FincasModel> = list();
    public sectores: DropdownData<SectorModel> = list();
    public parcelas: DropdownData<ParcelasModel | ParcelasModel[]> = list();
    public variedades: DropdownData<VisitasVariedadMesModel> = list();
    public compradores: DropdownData<string> = list();
    public clientes: DropdownData<ClienteModel> = list();
    public clientes_comercios: DropdownData<ClienteModel> = list();
    public cooperativas: DropdownData<string> = list();
    public alerta = false;

    public formFields: FormField<any>[] = [
    {
        name: 'id_finca',
        field: 'id_finca',
        label: 'Finca',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.fincas, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),        values: this.fincas,

        order: 1
    },
    {
        name: 'id_sector',
        field: 'id_sector',
        label: this.sectorName,
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.sectores, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: FilteredValue<SectorModel>) => it.value?.id_finca === getDropdownSelectedSingle(this.fincas)?.id }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.sectores,

        order: 2
    },
    {
        name: 'ids_parcelas',
        field: 'ids_parcelas',
        label: this.parcelasName,
        input: { type: InputType.MULTISELECT_SEARCH, isEditable: true, data: this.parcelas, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: FilteredValue<ParcelasModel>) => {
                const recogida = it.value;
                const selectedSector = getDropdownSelectedSingle(this.sectores);
                const selectedFinca = getDropdownSelectedSingle(this.fincas);

                if (selectedSector) {
                    return recogida?.id_sector === selectedSector.id
                        && recogida?.id_finca === selectedFinca?.id;
                }

                return recogida?.id_finca === selectedFinca?.id;
            } }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(this.appName === 'pyf' ? false : true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(this.appName === 'pyf' ? false : true),        values: this.parcelas,

        order: 3
    },
    {
        name: 'fecha',
        field: 'fecha',
        label: 'Fecha de Recogida',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'albaran',
        field: 'albaran',
        label: 'Nº Albarán',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 5
    },
    {
        name: 'lote',
        field: 'lote',
        label: 'Nº Lote',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 6
    },
    {
        name: 'id_variedad',
        field: 'id_variedad',
        label: 'Variedad',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.variedades, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: FilteredValue<VisitasVariedadMesModel>) => this.parcelas.filtered.some(p => 
                (p.value as ParcelasModel).id_variedad === it.value?.id) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'pyf') },
        required: false,
        visible: this.appName !== 'pyf',        values: this.variedades,

        order: 7
    },
    {
        name: 'cantidad',
        field: 'cantidad',
        label: 'Cantidad Kg',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),
        order: 8
    },
];




    private createReactiveForm(): void {
        const formType = Number(this.getType()) as FormType;
        this.reactiveForm = {
            formType,
            model: this.model,
            formFields: {
                name: 'recogidas',
                header: this.getType() === FormType.EDITION ? this.headerTitleWhenEdit : this.headerTitleWhenNew,
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
            },
        };
    }

    private getReactiveSections(): FormSection<RecogidaModel>[] {
        return [
            { name: 'Datos de recogida', fields: this.formFields, width: 12, isVisible: true, order: 1 },
        ];
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<RecogidaModel>): void {
        this.model = this.updateHostModel({ ...this.model, ...event.value } as RecogidaModel);
        this.handleUserValueChange(String(event.changedField ?? ''));
        if (this.reactiveForm) {
            this.reactiveForm.model = this.model;
        }
    }

    constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public clientesApi: ClientesApiService,
        public recogidasApi: RecogidasApiService,
        public fincasApi: FincasApiService,
        public formApi: FormCommonApiService,
        public siexApi: SiexApiService,
        public override router: Router
    ) {
        super(
            route,
            router,
            dashboard,
            recogidasApi.recogidasPUT,
            recogidasApi.recogidasPOST,
            'recogidas',
            'Actualizar Recogida',
            'Crear Recogida'
        );
    }

    ngOnInit() {
        this.model = this.initializeHostModel({ ...this.model, ...this.getModel() });
        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.model);
        this.initFormData();

        this.createReactiveForm();
        this.softInit(this.getType());
    }



    private handleUserValueChange(tag: string): void {


        if (tag === 'id_finca') {
            this.model.id_sector = null;
            this.model.ids_parcelas = null;
            this.model.id_variedad = null;
        }
        if (tag === 'id_sector') {
            this.model.ids_parcelas = null;
            this.model.id_variedad = null;
        }
        if (tag === 'ids_parcelas') {
            this.model.id_variedad = null;
        }
        if (tag === 'id_variedad') {
            this.recogidasApi.plazoSeguridadGET.toPromise({
                ids_parcelas: this.model.ids_parcelas,
                id_variedad: this.model.id_variedad} as never).then(res => {
                const unknown = res as unknown;
                const producto = unknown as ProductosModel;
                if ('nombre' in producto) {

                    this.model.producto_nombre = producto.nombre ?? '';
                    this.model.plazo_seguridad = producto.ps ?? '';
                    this.model.fecha_aplicacion = moment(producto.fecha_inicio, 'DD/MM/YYYY').format('DD/MM/YYYY');
                    if (this.model.plazo_seguridad !== 'NP') {
                        this.model.prohibido_hasta =
                        moment(producto.fecha_inicio, 'DD/MM/YYYY').add(this.model.plazo_seguridad, 'days').format('DD/MM/YYYY');
    
                        const fechaRecogida = moment(this.model.fecha, 'DD/MM/YYYY');
                        const prohibidoHasta =  moment(this.model.prohibido_hasta, 'DD/MM/YYYY');
                        this.alerta = fechaRecogida.diff(
                            prohibidoHasta, 'days') < 0 &&
                            fechaRecogida.diff(prohibidoHasta, 'days') >= -(this.model.plazo_seguridad ?? 0);
                    }
                }

                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }

        this.countSuperficieParcelas();
    }

    public selectAll() {
        this.countSuperficieParcelas();
    }

    public countSuperficieParcelas() {
        const ids = (this.model.ids_parcelas || '').split(';');
        this.model.parcelas_superficie = '0';

        (this.parcelas.filtered || []).forEach(parcela => {
            if (parcela && parcela.value && ids.includes((parcela.value as ParcelasModel).id) && this.model.parcelas_superficie) {
                this.model.parcelas_superficie +=
                    parseFloat(((parcela.value as ParcelasModel).superficie_cultivada || '').replace(',', '.') || '0.00');
            }
        });
        this.model.parcelas_superficie = Utils.decimalFormat(this.model.parcelas_superficie, 2, '.', ',', 3);

        const idxParcelas = this.getItemPosition(this.formFields, 'ids_parcelas');
        (this.formFields[idxParcelas] as FormField<object>).label = this.parcelasName + ' (' + this.tipoSuperficieParcelas
            + ':\xa0' + this.model.parcelas_superficie + '\xa0' + this.textoSuperficie + ')';
    }

    public override getItemPosition(formFields: FormField<object>[], field: string) {
        let position = -1;
        formFields.forEach((item, index) => {
            if (item.name === field) {
                position = index;
            }
        });
        return position;
    }

    private initFormData() {
        const builds = [
            build(this.fincasApi.fincasGET, this.fincas, 'nombre'),
            build(this.fincasApi.sectoresGET, this.sectores, 'nombre', true),
            build(this.fincasApi.parcelasGET, this.parcelas, 'nombre', true, true),
            build(
                environment.features.activateSIEX ? this.siexApi.variedadesClienteGET : this.formApi.variedadesGET,
                this.variedades,
                'variedad',
                true
            ),
            build(this.clientesApi.clientesGET, this.clientes, 'nombre'),
        ];
        pool(builds, () => {
            setTimeout(() => {
                if (this.fincas.filtered.length === 2 && this.getType() === FormType.CREATION) {
                    this.model.id_finca = (this.fincas.filtered[1]?.value as FincasModel).id;
                }

                this.countSuperficieParcelas();
                this.formBuilderRef?.updateForm(this.model as unknown as Record<string, unknown>, false);
            this.finalizeExternalDropdowns();
            }, 3000);
        });
    }
}
